import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateBranchGeneralDetailsRequest extends BaseUpdateRequest {
    registeredName = '';    
    taxNumber = '';    
    registrationNumber = '';
}